import React from 'react';

import PropTypes from 'prop-types';
import Select from 'react-select';

const MultiSelect = ({ label, options, updateFilters, value }) => {
  const styles = {
    option: provided => ({
      ...provided,
      borderBottom: '1px solid #e3e3e3',
      fontWeight: 100,
      color: '#555',
      backgroundColor: 'white'
    }),
    control: () => ({
      display: 'flex',
      borderRadius: '3px',
      border: '1px solid #333'
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.data.color,
      fontSize: state.selectProps.myFontSize
    }),
    // A z-index of 1 gets trapped behind later siblings that create their own stacking
    // context - render the menu in a body-level portal so it always paints on top.
    menuPortal: provided => ({ ...provided, zIndex: 9999 })
  };

  return (
    <div className="dropdown-main-container">
      <h4>{label}</h4>
      <div className="dropdown-container">
        <Select
          value={value}
          onChange={selectedValue => {
            updateFilters(selectedValue);
          }}
          isMulti
          options={options}
          styles={styles}
          menuShouldScrollIntoView={false}
          menuPortalTarget={document.body}
        />
      </div>
    </div>
  );
};

MultiSelect.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  updateFilters: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default MultiSelect;
